import React from 'react';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Badge } from '../../components/ui/badge';
import { Button } from '../../components/ui/button';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '../../components/ui/tabs';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../../components/ui/tooltip';
import { Calculator, AlertCircle, CheckCircle, List, Lock, FileText, Calendar, AlertTriangle, Info, RotateCcw } from 'lucide-react';
import SelecteurActivites from '../../components/SelecteurActivites';
import TerritoireSelector from '../../components/TerritoireSelector';
import { InlineError } from '../../components/ui/FormField';
import ActivitesSelectionSection from './ActivitesSelectionSection';
import MaitreOuvrageBloc from './MaitreOuvrageBloc';

export default function FormulaireSection({
  modeSimulateur, contratParent, modeCalcul, setModeCalcul, membreData,
  canAccessAnnuel, canAccessNominative,
  user: user, formData, setFormData, operationNominative, setOperationNominative,
  typesOperation, territoiresIntervention: territoiresIntervention, setTerritoiresIntervention: setTerritoiresIntervention,
  selectedActivitesGO, setSelectedActivitesGO,
  selectedActivites2nd, setSelectedActivites2nd,
  selectedActivitesPIB, setSelectedActivitesPIB,
  selectedActivitesTP, setSelectedActivitesTP,
  handleActivitesLoaded, activitesCompletes: activitesCompletes,
  errors, touched: touched, setTouched: setTouched, clearError,
  validitePersonnalisee: validitePersonnalisee, setValiditePersonnalisee: setValiditePersonnalisee,
  montantsPersonnalises: montantsPersonnalises, setMontantsPersonnalises: setMontantsPersonnalises,
  taxesPersonnalisees: taxesPersonnalisees, setTaxesPersonnalisees: setTaxesPersonnalisees,
  getSeuilCAActif, handleCalculer, loading, resultat, setResultat,
  handleReset, handleResetAvenant,
  caSyncedFromTerritoires = false
}) {
  return (
    <>
              {(modeSimulateur === 'souscription' || contratParent) && (
                <>
              {/* Toggle RCDS Annuel / Nominative - Design Pro */}
              <div className="bg-gradient-to-r from-slate-50 to-blue-50 p-4 rounded-xl border border-blue-100">
                <div className="flex items-center justify-between mb-3">
                  <Label className="text-sm font-semibold text-slate-700">Type de souscription</Label>
                  <TooltipProvider>
                    <Tooltip>
                      <TooltipTrigger asChild>
                        <AlertCircle className="h-4 w-4 text-slate-400 cursor-help" />
                      </TooltipTrigger>
                      <TooltipContent className="max-w-xs">
                        <p className="font-semibold mb-1">RCDS Annuel vs Nominative</p>
                        <p className="text-xs">• <strong>Annuel</strong> : Adhésion annuelle (COOPER'S)</p>
                        <p className="text-xs">• <strong>Nominative</strong> : Souscription par période/jours (Membres)</p>
                      </TooltipContent>
                    </Tooltip>
                  </TooltipProvider>
                </div>
                
                <div className="flex gap-3">
                  {/* Bouton RCDS Annuel */}
                  <TooltipProvider delayDuration={200}>
                    {!canAccessAnnuel ? (
                      <Tooltip>
                        <TooltipTrigger asChild>
                          <div className="flex-1">
                            <button
                              disabled
                              className="w-full p-4 rounded-xl border-2 border-slate-200 bg-slate-100 opacity-50 cursor-not-allowed"
                            >
                              <div className="flex items-center justify-center gap-2">
                                <div className="p-2 bg-slate-200 rounded-lg">
                                  <Lock className="h-4 w-4 text-slate-400" />
                                </div>
                                <div className="text-left">
                                  <div className="font-semibold text-slate-500">RCDS Annuel</div>
                                  <div className="text-xs text-slate-400">COOPER'S & Super Admin</div>
                                </div>
                              </div>
                            </button>
                          </div>
                        </TooltipTrigger>
                        <TooltipContent side="bottom" className="bg-red-600 text-white border-red-700 max-w-xs">
                          <p className="font-semibold">Accès réservé</p>
                          <p className="text-sm">Réservé aux COOPER'S et Super Administrateurs</p>
                        </TooltipContent>
                      </Tooltip>
                    ) : (
                      <button
                        onClick={() => setModeCalcul('annuel')}
                        className={`flex-1 p-4 rounded-xl border-2 transition-all duration-300 ${
                          modeCalcul === 'annuel'
                            ? 'border-blue-500 bg-gradient-to-br from-blue-50 to-blue-100 ring-2 ring-blue-200 shadow-lg'
                            : 'border-slate-200 bg-white hover:border-blue-300 hover:bg-blue-50/50'
                        }`}
                      >
                        <div className="flex items-center justify-center gap-3">
                          <div className={`p-2 rounded-lg transition-colors ${
                            modeCalcul === 'annuel' 
                              ? 'bg-blue-500 text-white' 
                              : 'bg-slate-100 text-slate-500'
                          }`}>
                            <Calendar className="h-5 w-5" />
                          </div>
                          <div className="text-left">
                            <div className={`font-bold ${modeCalcul === 'annuel' ? 'text-blue-700' : 'text-slate-700'}`}>
                              RCDS Annuel
                            </div>
                            <div className={`text-xs ${modeCalcul === 'annuel' ? 'text-blue-500' : 'text-slate-400'}`}>
                              Souscription annuelle
                            </div>
                          </div>
                          {modeCalcul === 'annuel' && (
                            <CheckCircle className="h-5 w-5 text-blue-500" />
                          )}
                        </div>
                      </button>
                    )}
                  </TooltipProvider>
                  
                  {/* Bouton RCDS Nominative — masque pour roles non admin (4.a) */}
                  {canAccessNominative && (
                    <button
                      onClick={() => setModeCalcul('nominative')}
                      className={`flex-1 p-4 rounded-xl border-2 transition-all duration-300 ${
                        modeCalcul === 'nominative'
                          ? 'border-purple-500 bg-gradient-to-br from-purple-50 to-purple-100 ring-2 ring-purple-200 shadow-lg'
                          : 'border-slate-200 bg-white hover:border-purple-300 hover:bg-purple-50/50'
                      }`}
                      data-testid="toggle-rcds-nominative"
                    >
                      <div className="flex items-center justify-center gap-3">
                        <div className={`p-2 rounded-lg transition-colors ${
                          modeCalcul === 'nominative' 
                            ? 'bg-purple-500 text-white' 
                            : 'bg-slate-100 text-slate-500'
                        }`}>
                          <FileText className="h-5 w-5" />
                        </div>
                        <div className="text-left">
                          <div className={`font-bold ${modeCalcul === 'nominative' ? 'text-purple-700' : 'text-slate-700'}`}>
                            RCDS Nominative
                          </div>
                          <div className={`text-xs ${modeCalcul === 'nominative' ? 'text-purple-500' : 'text-slate-400'}`}>
                            Par periode / jours
                          </div>
                        </div>
                        {modeCalcul === 'nominative' && (
                          <CheckCircle className="h-5 w-5 text-purple-500" />
                        )}
                      </div>
                    </button>
                  )}
                </div>
                
                {/* Info banner selon le mode */}
                <div className={`mt-3 p-3 rounded-lg text-sm ${
                  modeCalcul === 'annuel' 
                    ? 'bg-blue-600 text-white border border-blue-200' 
                    : 'bg-purple-600 text-white border border-purple-200'
                }`}>
                  {modeCalcul === 'annuel' ? (
                    <div className="flex items-center gap-2">
                      <Calendar className="h-4 w-4" />
                      <span><strong>Mode Annuel :</strong> Adhésion annuelle. Idéal pour les COOPER'S.</span>
                    </div>
                  ) : (
                    <div className="flex items-center gap-2">
                      <FileText className="h-4 w-4" />
                      <span><strong>Mode nominatif :</strong> adhésion valable sur une période définie (nombre de jours), réservée aux membres.</span>
                    </div>
                  )}
                </div>
              </div>

              {/* Paramètres de calcul - Design professionnel */}
              <div className="bg-gradient-to-br from-slate-50 to-blue-50/30 rounded-xl p-5 border border-slate-200 shadow-sm">
                <h4 className="text-sm font-bold text-slate-800 mb-4 flex items-center gap-2">
                  <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-blue-600 to-blue-700 flex items-center justify-center shadow-md">
                    <Calculator className="h-4 w-4 text-white" />
                  </div>
                  Paramètres de calcul
                </h4>
                
                <div className="space-y-4">
                  {/* Chiffre d'affaires */}
                  <div className="relative">
                    <Label htmlFor="ca_ht" className="text-sm font-semibold text-slate-700 mb-2 block">
                      Chiffre d&apos;affaires <span className="text-red-500">*</span>
                    </Label>
                    <div className={`relative ${errors.ca_ht ? 'animate-shake' : ''}`}>
                      <Input
                        id="ca_ht"
                        type="number"
                        min="0"
                        step="1000"
                        placeholder={getSeuilCAActif().actif 
                          ? `Minimum ${getSeuilCAActif().seuil.toLocaleString('fr-FR')} €`
                          : "Saisissez le CA (Montant de base)"
                        }
                        value={formData.ca_ht}
                        onChange={(e) => {
                          setFormData({ ...formData, ca_ht: e.target.value });
                          if (errors.ca_ht) clearError('ca_ht');
                          setResultat(null);
                        }}
                        className={`pr-12 h-12 text-lg font-semibold border-slate-300 focus:border-blue-500 focus:ring-blue-500 ${
                          errors.ca_ht ? 'border-red-500 focus:border-red-500 focus:ring-red-500 bg-red-50/50' : ''
                        }`}
                        data-testid="ca-ht-input"
                      />
                      <span className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-500 font-semibold">€</span>
                    </div>
                    {errors.ca_ht && <InlineError message={errors.ca_ht} />}
                    {formData.ca_ht && !errors.ca_ht && (
                      <p className="text-xs text-blue-600 mt-1 font-medium">
                        {Number(formData.ca_ht).toLocaleString('fr-FR')} €
                      </p>
                    )}
                    {caSyncedFromTerritoires && !errors.ca_ht && (
                      <div
                        className="flex items-center justify-between gap-2 mt-1.5 text-[11px] text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-md px-2 py-1"
                        data-testid="ca-sync-territoires-indicator"
                      >
                        <div className="flex items-center gap-1.5 min-w-0">
                          <Info className="h-3 w-3 text-emerald-600 shrink-0" />
                          <span className="truncate">
                            Calculé automatiquement depuis la ventilation par territoire
                            <span className="ml-1">✓</span>
                            <span className="text-emerald-600/70 ml-1">— modifiable manuellement</span>
                          </span>
                        </div>
                        <button
                          type="button"
                          onClick={() => {
                            setFormData({ ...formData, ca_ht: '' });
                            if (errors.ca_ht) clearError('ca_ht');
                            setResultat(null);
                          }}
                          className="shrink-0 flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-medium text-emerald-700 hover:text-white hover:bg-emerald-600 border border-emerald-300 transition-colors"
                          data-testid="ca-reset-from-territoires"
                          title="Vider ce champ pour saisir une autre valeur"
                        >
                          <RotateCcw className="h-3 w-3" />
                          Réinitialiser ce champ
                        </button>
                      </div>
                    )}
                    {/* Indicateur du seuil CA configuré - dynamique selon le type de souscription */}
                    {getSeuilCAActif().actif && (
                      <div className="flex items-center gap-2 mt-2 p-2 bg-amber-50 border border-amber-200 rounded-lg">
                        <AlertTriangle className="w-4 h-4 text-amber-600 flex-shrink-0" />
                        <p className="text-xs text-amber-700">
                          Seuil CA minimum configuré : <span className="font-bold">{getSeuilCAActif().seuil.toLocaleString('fr-FR')} €</span>
                          {getSeuilCAActif().message && (
                            <span className="ml-1 text-amber-600">({getSeuilCAActif().message})</span>
                          )}
                        </p>
                      </div>
                    )}
                    {/* Info CA contrat parent en mode avenant */}
                    {modeSimulateur === 'avenant' && contratParent?.chiffre_affaires && (
                      <div className="flex items-center justify-between mt-2 p-2 bg-green-50 border border-green-200 rounded-lg">
                        <p className="text-xs text-green-700">
                          CA du contrat parent : <span className="font-bold">{contratParent.chiffre_affaires.toLocaleString('fr-FR')} €</span>
                        </p>
                        {formData.ca_ht !== contratParent.chiffre_affaires.toString() && (
                          <Button
                            type="button"
                            variant="ghost"
                            size="sm"
                            className="text-xs text-green-700 hover:text-green-900 hover:bg-green-100 h-6 px-2"
                            onClick={() => {
                              setFormData({ ...formData, ca_ht: contratParent.chiffre_affaires.toString() });
                              setResultat(null);
                            }}
                          >
                            Reprendre
                          </Button>
                        )}
                      </div>
                    )}
                  </div>

                  {/* Nombre de jours - Mode nominative */}
                  {modeCalcul === 'nominative' && (
                    <div className="relative pt-3 border-t border-slate-200">
                      <Label htmlFor="nombre_jours" className="text-sm font-semibold text-slate-700 mb-2 block">
                        Durée de couverture <span className="text-red-500">*</span>
                      </Label>
                      <div className={`flex items-center gap-3 ${errors.nombre_jours ? 'animate-shake' : ''}`}>
                        <div className="relative flex-1">
                          <Input
                            id="nombre_jours"
                            type="number"
                            min="1"
                            max="360"
                            placeholder="180"
                            value={formData.nombre_jours}
                            onChange={(e) => {
                              setFormData({ ...formData, nombre_jours: e.target.value });
                              if (errors.nombre_jours) clearError('nombre_jours');
                            }}
                            className={`h-12 text-lg font-semibold border-slate-300 focus:border-purple-500 focus:ring-purple-500 ${
                              errors.nombre_jours ? 'border-red-500 focus:border-red-500 focus:ring-red-500 bg-red-50/50' : ''
                            }`}
                            data-testid="nombre-jours-input"
                          />
                        </div>
                        <span className="text-sm font-semibold text-slate-600 whitespace-nowrap">jours</span>
                      </div>
                      {errors.nombre_jours && <InlineError message={errors.nombre_jours} />}
                      {!errors.nombre_jours && (
                        <div className="flex items-center justify-between mt-2">
                          <p className="text-xs text-slate-500">
                            Base annuelle : <span className="font-semibold">360 jours</span>
                          </p>
                          {formData.nombre_jours && (
                            <p className="text-xs text-purple-600 font-medium">
                              ≈ {(Number(formData.nombre_jours) / 30).toFixed(1)} mois
                            </p>
                          )}
                        </div>
                      )}
                    </div>
                  )}

                  {/* Champs spécifiques souscription nominative */}
                  {modeCalcul === 'nominative' && (
                    <div className="space-y-4 pt-4 border-t border-purple-200 bg-purple-50/50 rounded-xl p-4 mt-4">
                      <div className="flex items-center gap-2 mb-3">
                        <div className="w-8 h-8 rounded-lg bg-purple-100 flex items-center justify-center">
                          <FileText className="h-4 w-4 text-purple-600" />
                        </div>
                        <div>
                          <h4 className="text-sm font-semibold text-purple-800">Détails de l'opération</h4>
                          <p className="text-xs text-purple-600">Informations complémentaires pour la souscription nominative</p>
                        </div>
                      </div>

                      {/* Type d'opération */}
                      <div>
                        <Label className="text-sm font-semibold text-slate-700 mb-2 block">
                          Type d'opération
                        </Label>
                        <select
                          value={operationNominative.type_operation}
                          onChange={(e) => setOperationNominative(prev => ({ ...prev, type_operation: e.target.value }))}
                          className="w-full h-11 px-3 py-2 text-sm rounded-lg border border-slate-300 bg-white focus:border-purple-500 focus:ring-2 focus:ring-purple-200 transition-all"
                          data-testid="type-operation-select"
                        >
                          <option value="">-- Sélectionnez un type --</option>
                          {typesOperation.map(opt => (
                            <option key={opt.value} value={opt.value}>{opt.label}</option>
                          ))}
                        </select>
                      </div>

                      {/* Description de l'opération */}
                      <div>
                        <Label className="text-sm font-semibold text-slate-700 mb-2 block">
                          Description de l'opération
                        </Label>
                        <textarea
                          placeholder="Décrivez brièvement l'opération (nature des travaux, objectifs...)"
                          value={operationNominative.description_operation}
                          onChange={(e) => setOperationNominative(prev => ({ ...prev, description_operation: e.target.value }))}
                          className="w-full h-20 px-3 py-2 text-sm border-2 border-slate-200 rounded-lg focus:border-blue-500 focus:ring-1 focus:ring-blue-500 resize-none"
                          data-testid="description-operation-input"
                        />
                      </div>

                      {/* Territoire d'intervention - Sélecteur professionnel */}
                      <div>
                        <Label className="text-sm font-semibold text-slate-700 mb-2 block">
                          Territoire d'intervention
                        </Label>
                        <TerritoireSelector
                          value={operationNominative.territoire_intervention}
                          onChange={(value) => setOperationNominative(prev => ({ ...prev, territoire_intervention: value }))}
                        />
                      </div>

                      {/* Adresse de l'opération */}
                      <div className="space-y-3">
                        <Label className="text-sm font-semibold text-slate-700 block">
                          Adresse de l'opération
                        </Label>
                        <Input
                          placeholder="Numéro et nom de la voie"
                          value={operationNominative.adresse_operation}
                          onChange={(e) => setOperationNominative(prev => ({ ...prev, adresse_operation: e.target.value }))}
                          className="h-10 text-sm"
                          data-testid="adresse-operation-input"
                        />
                        <div className="grid grid-cols-2 gap-3">
                          <Input
                            placeholder="Code postal"
                            value={operationNominative.code_postal_operation}
                            onChange={(e) => setOperationNominative(prev => ({ ...prev, code_postal_operation: e.target.value }))}
                            className="h-10 text-sm"
                            data-testid="code-postal-operation-input"
                          />
                          <Input
                            placeholder="Ville"
                            value={operationNominative.ville_operation}
                            onChange={(e) => setOperationNominative(prev => ({ ...prev, ville_operation: e.target.value }))}
                            className="h-10 text-sm"
                            data-testid="ville-operation-input"
                          />
                        </div>
                        {/* Pays avec drapeau français */}
                        <div 
                          className="h-12 px-4 rounded-xl border-2 border-slate-200 bg-gradient-to-r from-blue-50 via-white to-red-50 flex items-center gap-3 cursor-default"
                          data-testid="pays-operation-display"
                        >
                          {/* Drapeau SVG tricolore */}
                          <svg width="32" height="22" viewBox="0 0 3 2" className="rounded shadow-sm border border-slate-200">
                            <rect width="1" height="2" x="0" fill="#002395"/>
                            <rect width="1" height="2" x="1" fill="#FFFFFF"/>
                            <rect width="1" height="2" x="2" fill="#ED2939"/>
                          </svg>
                          <span className="font-semibold text-slate-700">France</span>
                          <span className="ml-auto text-xs text-slate-400 bg-slate-100 px-2 py-1 rounded-full">République Française</span>
                        </div>
                      </div>

                      <MaitreOuvrageBloc
                        value={formData.maitre_ouvrage}
                        membreId={membreData?.membre_id || membreData?.id || new URLSearchParams(window.location.search).get('membre_id') || new URLSearchParams(window.location.search).get('membre')}
                        onChange={(mo) => setFormData(prev => ({ ...prev, maitre_ouvrage: mo }))}
                      />
                    </div>
                  )}
                </div>
              </div>

              <ActivitesSelectionSection
                selectedActivitesGO={selectedActivitesGO}
                setSelectedActivitesGO={setSelectedActivitesGO}
                selectedActivites2nd={selectedActivites2nd}
                setSelectedActivites2nd={setSelectedActivites2nd}
                selectedActivitesPIB={selectedActivitesPIB}
                setSelectedActivitesPIB={setSelectedActivitesPIB}
                selectedActivitesTP={selectedActivitesTP}
                setSelectedActivitesTP={setSelectedActivitesTP}
                errors={errors}
                clearError={clearError}
                handleActivitesLoaded={handleActivitesLoaded}
                activitesCouvertes={modeSimulateur === 'avenant' ? (contratParent?.activites_selectionnees || {}) : {}}
              />

              <div className="flex gap-3">
                <Button 
                  onClick={async () => {
                    await handleCalculer();
                    // Auto-scroll vers le Montant HT dans le résultat
                    setTimeout(() => {
                      const montantEl = document.getElementById('montant-ht-result');
                      if (montantEl) {
                        montantEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
                        // Ajouter un effet de highlight
                        montantEl.classList.add('ring-4', 'ring-blue-400', 'ring-opacity-75');
                        setTimeout(() => {
                          montantEl.classList.remove('ring-4', 'ring-blue-400', 'ring-opacity-75');
                        }, 2000);
                      }
                    }, 400);
                  }} 
                  disabled={loading}
                  className={`flex-1 transition-all duration-300 ${
                    modeSimulateur === 'avenant' 
                      ? (resultat ? 'bg-green-600 hover:bg-green-700' : 'bg-purple-600 hover:bg-purple-700')
                      : (resultat ? 'bg-green-600 hover:bg-green-700' : '')
                  }`}
                  data-testid="calculer-btn"
                >
                  {loading ? 'Calcul en cours...' : (
                    resultat 
                      ? (modeSimulateur === 'avenant' ? '✓ Recalculer le coût de l\'avenant' : '✓ Recalculer ma contribution')
                      : (modeSimulateur === 'avenant' ? 'Calculer le coût de l\'avenant' : 'Calculer ma contribution')
                  )}
                </Button>
                <Button 
                  onClick={modeSimulateur === 'avenant' ? handleResetAvenant : handleReset} 
                  variant="outline"
                  data-testid="reset-btn"
                >
                  Réinitialiser
                </Button>
              </div>
                </>
              )}
    </>
  );
}
